import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

const Header = ({ backgroundImages, title, subtitle, buttonON }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
    };

    const goToImage = (index) => {
        setCurrentImageIndex(index);
    };

    useEffect(() => {
        const intervalId = setInterval(nextImage, 5000);
        return () => clearInterval(intervalId); 
    }, []); 

    let textStrokeValue = "1px"; 
    if (screenWidth >= 768) {
        textStrokeValue = "3px"; 
    }
    if (screenWidth >= 1024) {
        textStrokeValue = "5px";
    }

    return (
        <header id="header" className="relative h-screen bg-cover bg-center text-[#FFFFFF] z-0">
            <div className="absolute inset-0 w-full h-full flex overflow-hidden">
                {backgroundImages.map((image, index) => (
                    <div
                        key={index}
                        className={`flex-shrink-0 w-full h-full bg-cover bg-center absolute transition-all duration-700 ease-in-out`}
                        style={{
                            backgroundImage: `url(${image})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            opacity: currentImageIndex === index ? 1 : 0, 
                            filter: currentImageIndex === index ? "blur(0)" : "blur(10px)", 
                            transition: "opacity 0.7s ease-in-out, filter 0.7s ease-in-out",
                        }}
                    />
                ))}
            </div>

            <div className="h-screen flex flex-col justify-center items-center text-center relative">
                <div className="absolute inset-0 bg-black opacity-25 z-5"></div>
                <h1
                    className={`font-customFont1 text-6xl font-black md:text-8xl lg:text-9xl transition-all duration-700 ease-in-out z-10`}
                    style={{
                        WebkitTextStroke: textStrokeValue,
                        textStroke: textStrokeValue,
                    }}
                >
                    {title}
                </h1>
                <h1 className={`font-customFont2 text-3xl font-bold md:text-5xl lg:text-6xl transition-all duration-700 ease-in-out z-10`}>
                    {subtitle}
                </h1>
                {buttonON && ( 
                    <Link to="/#first-section" className="relative border text-center rounded-xl border-[#ffffff] text-[#ffffff] px-5 py-1.5 group overflow-hidden transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-[#ffffff] hover:text-[#13455a] z-10">
                        EXPLORER
                    </Link>
                )}

                <div className="absolute bottom-5 flex space-x-3 z-10">
                    {backgroundImages.map((_, index) => (
                        <div
                            key={index}
                            onClick={() => goToImage(index)}
                            className={`cursor-pointer transition-all duration-300 ease-in-out ${
                                currentImageIndex === index 
                                    ? 'bg-[#ffffff] h-3 w-8 rounded-xl'
                                    : 'bg-[#ffffff] opacity-50 w-3 h-3 rounded-xl'
                            }`}
                        ></div>
                    ))}
                </div>
            </div>
        </header>
    );
};

export default Header;
